import { default as RLayerRaster } from './RLayerRaster';
/**
 * An abstract layer serving as base to the WebGL layers
 *
 * Requires an `RMap` context
 */
export default class RLayerWebGL extends RLayerRaster {
}
//# sourceMappingURL=RLayerWebGL.js.map